module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "media reply"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content pt-2"
  }, [_c('section', {
    staticClass: "user-name-container flex-wrap"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('img', {
    staticClass: "image is-32x32 mr-1 rounded",
    attrs: {
      "src": _vm.avatar_url
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('UpdatingTime', {
    staticClass: "text-muted",
    attrs: {
      "time": _vm.created_on
    }
  })], 1), _vm._v(" "), (!_vm.editing) ? _c('p', {
    staticClass: "white-space-pre"
  }, [_vm._v(_vm._s(_vm.body))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('textarea', {
    directives: [{
      name: "textautosize",
      rawName: "v-textautosize"
    }, {
      name: "select",
      rawName: "v-select"
    }],
    ref: "reply",
    staticClass: "textarea reply-textarea",
    attrs: {
      "placeholder": "Add a comment..."
    },
    domProps: {
      "value": _vm.body
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.editing = false
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.shiftKey) { return null; }
        _vm.updateReply(_vm.cycleID, _vm.videoID, _vm.commentID, _vm.id)
      }]
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-container mt-2"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "button is-small is-info",
    class: _vm.updating && 'is-loading',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateReply(_vm.cycleID, _vm.videoID, _vm.commentID, _vm.id)
      }
    }
  }, [_vm._v("\n              Save\n          ")]) : _vm._e(), _vm._v(" "), _c('span', [(_vm.editing) ? _c('button', {
    staticClass: "button is-small is-danger",
    class: _vm.deleting && 'is-loading',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteReply(_vm.cycleID, _vm.videoID, _vm.commentID, _vm.id)
      }
    }
  }, [_vm._v("\n              Delete\n            ")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-small",
    attrs: {
      "type": "button",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.editing && _vm.editable) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-67afa1d0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reply.vue
// module id = 1053
// module chunks = 0